import PropTypes from "prop-types"
import React from "react"
import {getImageUrl} from '@utils/image'
import { useUID } from "react-uid"
import ApartmentTherapy from '@svgs/apartment-therapy.svg'
import Rover from '@svgs/rover.svg'
import PetAge from '@svgs/pet-age.svg'
import HouseBeautiful from '@svgs/house-beautiful.svg'


const LogoList = ({ logos, title }) => {
  return (
    <div className="bg-white">
      {title && <h2 tabIndex={0} className="pl-0 md:pl-10">{title}</h2>}
      <div className="w-full max-w-screen-xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <div className="flex flex-wrap justify-center items-center md:gap-20">
          {logos && logos.length > 0 ? (
            <>
              {logos.map((logo, i) => (
                <>
                  {logo.url ? (
                    <a key={useUID(i)} href={logo.url} target="_blank">
                      <img className="flex-initial object-scale-down mb-4 h-4 sm:mb-0 sm:h-6 ml-2 mr-2 sm:ml-4 sm:mr-4" src={getImageUrl(logo.image)} alt={logo.image.alt} />
                    </a>
                  ) : (
                    <img className="flex-initial object-scale-down mb-4 h-4 sm:mb-0 sm:h-6 ml-2 mr-2 sm:ml-4 sm:mr-4" src={getImageUrl(logo.image)} alt={logo.image.alt} />
                  )}
                  
                </>
              ))}
            </>
            )
          : (
              <>
                <img className="flex-initial object-scale-down mb-4 h-4 sm:mb-0 sm:h-6 ml-2 mr-2 sm:ml-4 sm:mr-4" src={ApartmentTherapy} alt="Apartment Therapy" />
                <img className="flex-initial object-scale-down mb-4 h-4 sm:mb-0 sm:h-6 ml-2 mr-2 sm:ml-4 sm:mr-4" src={PetAge} alt="Pet Age" />
                <img className="flex-initial object-scale-down mb-4 h-4 sm:mb-0 sm:h-6 ml-2 mr-2 sm:ml-4 sm:mr-4" src={Rover} alt="Rover" />
                <img className="flex-initial object-scale-down mb-4 h-4 sm:mb-0 sm:h-6 ml-2 mr-2 sm:ml-4 sm:mr-4" src={HouseBeautiful} alt="House Beautiful" />
              </>
          )}
        </div>
      </div>
    </div>
)};

LogoList.propTypes = {
  siteTitle: PropTypes.string,
}

export default LogoList
